import * as keys from '../actions/project'
import Vue from 'vue'

const state = {
	project: {
		id: null,
		name: null,
		company: null,
		start_date: null,
		end_date: null,
		last_accessed: null,
		created_date: null,
		locked: false
	},

	prizes: [],

	products: []
}

const getters = {}

const mutations = {
	[keys.PROJECT_SAVE]: (state, project) => {
		Vue.set(state, 'project', project)
	},

	[keys.PROJECT_PRIZES_SET]: (state, prizes) => {
		state.prizes = prizes
	},

	[keys.PROJECT_PRIZES_ADD]: (state, prize) => {
		state.prizes.push(prize)
	},

	[keys.PROJECT_PRIZES_SAVE]: (state, prize) => {
		state.prizes[state.prizes.indexOf(prize)] = prize
	},

	[keys.PROJECT_PRIZES_REMOVE]: (state, prize) => {
		const index = state.prizes.indexOf(prize)

		if (index !== -1) {
			state.prizes.splice(index, 1)
		}
	},

	[keys.PROJECT_PRODUCTS_SET]: (state, products) => {
		state.products = products
	},

	[keys.PROJECT_PRODUCTS_ADD]: (state, product) => {
		state.products.push(product)
	},

	[keys.PROJECT_PRODUCTS_SAVE]: (state, product) => {
		state.products[state.products.indexOf(product)] = product
	},

	[keys.PROJECT_PRODUCTS_REMOVE]: (state, product) => {
		const index = state.products.indexOf(product)

		if (index !== -1) {
			state.products.splice(index, 1)
		}
	}
}

const actions = {
	[keys.PROJECT_FETCH]: ({ commit }, id) => {
		Vue.axios.get(`/projects/${id}`)
			.then(response => {
				commit(keys.PROJECT_SAVE, response.data)
			})
	},

	[keys.PROJECT_SAVE]: ({ commit }, project) => {
		if (Object.prototype.hasOwnProperty.call(project, 'id') && project.id > 0) {
			Vue.axios.put(`/projects/${project.id}`, project)
				.then(response => {
					commit(keys.PROJECT_SAVE, response.data)
				})
		} else {
			Vue.axios.post(`/projects`, project)
				.then(response => {
					commit(keys.PROJECT_SAVE, response.data)
				})
		}
	},

	[keys.PROJECT_LOCK]: ({ commit }, project) => {
		project.locked = true
		Vue.axios.put(`/projects/${project.id}`, project)
			.then(response => {
				commit(keys.PROJECT_SAVE, response.data)
			})
	},

	[keys.PROJECT_PRIZES_FETCH]: ({ commit }, id) => {
		Vue.axios.get(`/projects/${id}/prizes`)
			.then(response => {
				commit(keys.PROJECT_PRIZES_SET, response.data)
			})
	},

	[keys.PROJECT_PRODUCTS_FETCH]: ({ commit }, id) => {
		Vue.axios.get(`/projects/${id}/products`)
			.then(response => {
				commit(keys.PROJECT_PRODUCTS_SET, response.data)
			})
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
